// Generated by gen-hooks
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { iamListUserRefreshTokens } from '@crossnokaye/typescript-sdk/funcs/iamListUserRefreshTokens';
import { RefreshToken } from '@crossnokaye/typescript-sdk/models/components';
import {
  ListUserRefreshTokensRequest,
  ListUserRefreshTokensResponse,
} from '@crossnokaye/typescript-sdk/models/operations';

import { atlasClient } from '@/clients/atlas';

export type ListUserRefreshTokensOptions = Omit<
  UseQueryOptions<ListUserRefreshTokensResponse, Error, RefreshToken[] | undefined>,
  'queryFn'
>;

export type ListUserRefreshTokensTransformer = (
  response: ListUserRefreshTokensResponse
) => RefreshToken[] | undefined;

export type ListUserRefreshTokensResult = UseQueryResult<RefreshToken[] | undefined, Error>;

export const fetchUserRefreshTokens = (request: ListUserRefreshTokensRequest) =>
  atlasClient<ListUserRefreshTokensRequest, ListUserRefreshTokensResponse>({
    atlasFunc: iamListUserRefreshTokens,
    request,
  });

export const transformListUserRefreshTokensResponse = (response: ListUserRefreshTokensResponse) =>
  response.listUserRefreshTokensResponseBody?.values?.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  ) ?? [];

export function useListUserRefreshTokens(
  request: ListUserRefreshTokensRequest,
  options?: ListUserRefreshTokensOptions,
  transformer?: ListUserRefreshTokensTransformer
): ListUserRefreshTokensResult {
  const defaultQueryKey = ['iam', 'ListUserRefreshTokens', request] as const;

  return useQuery<ListUserRefreshTokensResponse, Error, RefreshToken[] | undefined>({
    queryKey: options?.queryKey ?? defaultQueryKey,
    queryFn: () => fetchUserRefreshTokens(request),
    select: transformer ?? transformListUserRefreshTokensResponse,
    ...options,
  });
}
